import GenericTableResponse from "@/models/api/GenericTableResponse";
import { Expose, Type } from "class-transformer";
import { IsNumber, IsString, ValidateNested } from "class-validator";

export default class CreditCardStatement {
  @IsNumber()
  @Expose()
  id!: number;
  @IsNumber()
  @Expose()
  bankType!: number; // 1,
  @IsString()
  @Expose()
  creditCardNumber!: string; //"5476 XXXX XXXX 9175",ł
  @IsString()
  @Expose()
  currency!: string; // "PLN",
  @IsString()
  @Expose()
  fromDate!: string; //"2020-09-01T00:00:00",
  @IsString()
  @Expose()
  toDate!: string; // "2020-09-30T23:59:59.997",
  @IsString()
  @Expose()
  createdAt!: string; // "2020-10-07T08:08:58.08",
  @IsString()
  @Expose()
  createdBy!: string; // "wpaszko",
  @IsString()
  @Expose()
  statementNumber!: string; //"RKB/1/09/2020/5543"
}

export class CreditCardStatementsResponse extends GenericTableResponse<CreditCardStatement> {
  @Type(() => CreditCardStatement)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<CreditCardStatement>;
}
